module.exports = __webpack_public_path__ + "static/media/comment.1b5047ef.svg";